import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../redux/index';
import { fetchPracticeById } from '../../redux/practice/practiceSlice';
import { useCallback } from 'react';

export const usePracticeById = () => {
    const dispatch = useDispatch();
    const {practice,  selectedPractice, isLoading, error} = useSelector((state: RootState) => state.practices);

    const fetchPracticeDetails = useCallback((practiceId: string) => {
        dispatch(fetchPracticeById(practiceId) as any);
    }, [dispatch]);

    return { practice, isLoading,  selectedPractice, error, fetchPracticeDetails };
}